// Clean, display-only case name. Strips a leading "The" and the word "Case",
// while keeping any parenthetical alias.
//   "The Scott Peterson Case (Laci Peterson)" -> "Scott Peterson (Laci Peterson)"
//   "The Bryan Kohberger Case" -> "Bryan Kohberger"
// NOTE: display only — never used for slugs, URLs, or stored titles.
export function caseDisplayName(title = "") {
  return (title || "")
    .replace(/^the\s+/i, "")
    .replace(/\s+case(\s*\()/i, "$1")
    .replace(/\s+case\s*$/i, "")
    .trim();
}
